'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "error", "fieldType", "value"];
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { getTransferableProps } from './filterInputProps';
import { fromSimpleDate, toSimpleDate } from '../../utilities/momentSimpleDateConversion';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorDateInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = evt => {
      const {
        onChange,
        fieldType
      } = this.props;
      onChange(syntheticEvent(fromSimpleDate(fieldType, evt.target.value)));
    };
    this.handleOpenChange = evt => {
      const {
        onBlur
      } = this.props;
      if (!evt.target.value && onBlur) {
        onBlur();
      }
    };
  }
  render() {
    const _this$props = this.props,
      {
        className,
        error,
        fieldType,
        value
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const transferableProps = getTransferableProps(rest);
    const {
      ['data-selenium-test']: dataSeleniumTest,
      placeholder,
      disabled,
      onKeyDown,
      onKeyPress,
      onKeyUp,
      readOnly
    } = transferableProps;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UIDateInput, {
        className: className,
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        onChange: this.handleChange,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onOpenChange: this.handleOpenChange,
        placeholder: placeholder,
        readOnly: readOnly,
        value: toSimpleDate(fieldType, value)
      })
    });
  }
}
FilterOperatorDateInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  fieldType: PropTypes.oneOf([DATE, DATE_TIME]).isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};